import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import { Input, Spinner } from "components"
import { getMapSearch } from "services"
import classes from "./CdsamMapSearch.module.scss"
import clsx from "clsx"

const CdsamMapSearch = (props) => {
  const { form, setForm } = props

  const [t, i18n] = useTranslation()

  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState("")
  const [results, setResults] = useState([])
  const [showMenu, setShowMenu] = useState(false)

  const timout = useRef()
  const unmount = useRef(false)

  const handleFocus = () => {
    setShowMenu(results.length > 0)
  }

  const handleSelect = async (result) => {
    setShowMenu(false)

    setSearch("")

    setResults([])

    setForm(prev => ({
      ...prev,
      coordinates: [result.location.x, result.location.y]
    }))
  }

  const handleSearch = async (term) => {
    setLoading(true)

    const query = {
      term,
      lat: form.coordinates[0],
      lng: form.coordinates[1]
    }

    try {
      const data = await getMapSearch(query)

      if (unmount.current) return

      setResults(data.items.slice(0, 5))

      setShowMenu(data.items.length > 0)
    } catch (err) {
      console.log(err)
    }

    setLoading(false)
  }

  const handleChange = (e) => {
    setSearch(e.target.value)

    const term = e.target.value.trim()

    if (term.length < 3) {
      setLoading(false)

      setShowMenu(false)

      setResults([])

      clearTimeout(timout.current)

      return
    }

    clearTimeout(timout.current)

    timout.current = setTimeout(() => handleSearch(term), 700)
  }

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true

      clearTimeout(timout.current)
    }
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["search-container"]}>
      <div className={classes["search-wrapper"]}>
        <Input
          type="text"
          placeholder={t("جست_و_جوی_آدرس")}
          value={search}
          onClick={(e) => e.stopPropagation()}
          onFocus={handleFocus}
          onChange={handleChange}
          className={clsx(
            classes["input"],
            isLtr && classes["input-ltr"]
          )}
        />
        {
          loading &&
          <Spinner
            size={18}
            color="var(--color-primary)"
            className={clsx(
              classes["loader"],
              isLtr && classes["loader-ltr"]
            )}
          />
        }
      </div>
      {
        showMenu &&
        <div
          className={clsx(
            classes["menu"],
            isLtr && classes["menu-ltr"]
          )}
        >
          {results.map((result, rIndex) =>
            <div
              key={rIndex}
              onClick={() => handleSelect(result)}
              title={`${result.title}، ${result.address}`}
              className={classes["menu-item"]}
            >
              {result.title}، {result.address}
            </div>
          )}
        </div>
      }
    </div>
  )
}

export default CdsamMapSearch